import { ID } from '~/lib/model';

export interface IPresetBulkAssignment {
    resourceIds: ID[];
    presetId: number | null;
}

export const defaultPresetBulkAssignment: IPresetBulkAssignment = {
    resourceIds: [],
    presetId: null,
};
